import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import editIcon from "../../../Assets/Table/edit-icon.svg";
import deleteIcon from "../../../Assets/Table/delete-icon.svg";
import { checkPermission } from "../../../Utils/Permissions";

export function TreatmentList({
  name,
  handleDelete,
  handleEdit,
  onClick,
  selected,
  noIcon,
}) {
  return (
    <Grid paddingX={"15px"}>
      <Grid
        paddingTop={"15px"}
        paddingLeft={"15px"}
        marginBottom={"8px"}
        item
        container
        lg={12}
        onClick={onClick}
        sx={{
          cursor: "pointer",
        }}
        boxShadow={selected ? "rgba(149, 157, 165, 0.2) 0px 5px 20px;" : "none"}
        border={`1px solid ${selected ? "#e7eef6" : "none"}`}
        bgcolor={`${selected ? "red" : "none"}`}
      >
        <Grid item lg={6}>
          <Typography fontSize={"15px"}>{name}</Typography>
        </Grid>
        <Grid container item justifyContent="flex-end" lg={6}>
          <Grid container width={"140px"}>
            {checkPermission("DB_TREATMENT_EDIT") && (
              <>
                {!noIcon && (
                  <Button onClick={handleEdit}>
                    <Box component={"img"} src={editIcon} />
                  </Button>
                )}
              </>
            )}
            {checkPermission("DB_TREATMENT_DELETE") && (
              <>
                {!noIcon && (
                  <Button onClick={handleDelete}>
                    {!noIcon && <Box component={"img"} src={deleteIcon} />}
                  </Button>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </Grid>
  );
}
